// src/enums/task-remind_in.enum.ts
export enum TaskRemindIn {
  ONE_HOUR = '1 hour',
  ONE_DAY = '1 day',
  ONE_WEEK = '1 week',
  ONE_MONTH = '1 month',
  CUSTOM = 'custom',
}
